<script>
    import Placeholder from "@component/Placeholder.svelte";
    export let route;
</script>

<Placeholder name="header" {route}/>
<Placeholder name="main" {route}/>
<Placeholder name="footer" {route}/>
